<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="col col-xs-12">
    <div class="padding-main-side table-filter">
      <!--header-->
      <div class="col-md-12 dash-side">
        <div class="row add-m-b">
          <div class="col-md-6 col-9">
            <h5 class="heading-super mb-2">
              <i class="fa fa fa-cogs"></i> Role / Menu
            </h5>
          </div>
          <div class="col-md-6 col-3 text-right">
            <span class="home-1" [routerLink]="['/setups']">
              <i class="fa fa-home ml-3"></i>
            </span>
          </div>
        </div>
      </div>
      <!--end header-->
      <div class="col-lg-12 col-md-12 col-sm-12 line-tabs"> 
        <ul class="nav d-flex">
          <li class="nav-item">
            <a
              href="#menu_map"
              data-toggle="tab"
              class="nav-link tab-border mr-3 active"
            >
              <i class="fa fa-map"></i> Role Menu Mapping
            </a>
          </li>
        </ul>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
        <div class="tab-content">
          <div id="menu_map" class="pro-overview tab-pane fade show active">
            <!-- component1 -->

            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 top-corner-items m-b-10">
                <button
                  type="button"
                  class="btn btn-primary btn-side-right mt-n3"
                  (click)="openModal('#add_menu_role', 'Add Menu Role Mapping')"
                >
                  <i class="fa fa-plus"></i>
                  {{ "Add Role Menu Mapping" | translate }}
                </button>
              </div>
            </div>

            <div class="table-filter bg-main mt-1 p-3">
              <div class="row">
                <div class="col-md-4 col-8">
                  <div class="form-group">
                    <label>{{ "Search By" | translate }}</label>
                    <select class="form-control">
                      <option value="">{{ "Select" | translate }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-8">
                  <div class="form-group">
                    <label>{{ "Search By Organization" | translate }}</label>
                    <select class="form-control">
                      <option value="">{{ "Select" | translate }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-8" *ngIf="relatedSearch == 1">
                  <div class="form-group">
                    <label>{{ "Select Role" | translate }}</label>
                    <select class="form-control">
                      <option value="">{{ "Select" | translate }}</option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-md-4 col-8"
                  *ngIf="
                    relatedSearch == 0 ||
                    relatedSearch == 2 ||
                    relatedSearch == 3
                  "
                >
                  <div class="form-group">
                    <label>{{ "Select Application" | translate }}</label>
                    <select class="form-control">
                      <option value="">{{ "Select" | translate }}</option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-md-4 col-8"
                  *ngIf="relatedSearch == 2 || relatedSearch == 3"
                >
                  <div class="form-group">
                    <label>{{ "Select Menu" | translate }}</label>
                    <select class="form-control" [(ngModel)]="mnuHide">
                      <option value="">{{ "Select" | translate }}</option>
                      <option
                        *ngFor="let data of mnuList"
                        value="{{ data.value }}"
                      >
                        {{ data.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-8" *ngIf="relatedSearch == 3">
                  <div class="form-group">
                    <label>{{ "Select Submenu" | translate }}</label>
                    <select class="form-control" [(ngModel)]="sbmnuHide">
                      <option value="">{{ "Select" | translate }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12 col-12">
                  <div class="text-center">
                    <button
                      class="btn btn-danger btn-sm"
                      (click)="resetSearch()"
                    >
                      {{ "Reset" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- table -->

            <div class="mt-4">
              <div class="row tele1">
                <div class="col-6">
                  <p class="fs-12 font-weight-bold text-color-main mb-2">
                    {{ from }} - {{ to }} of {{ count }} results
                  </p>
                </div>
                <div class="col-3"></div>
                <div class="col-3 mb-2"></div>

                <div class="col-md-12 table-responsive">
                  <table class="table bg-white" cellspacing="0" width="100%">
                    <thead class="bg-table-header1">
                      <tr>
                        <th>S.No</th>
                        <th>Org</th>
                        <th>Application Name</th>
                        <th>Menu Name</th>
                        <th>Sub Menu</th>
                        <th>Role Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="roleMenu.length > 0; else noData">
                        <tr
                          *ngFor="
                            let data of roleMenu
                              | paginate
                                : {
                                    id: 'myqrypage',
                                    itemsPerPage: pageSize,
                                    currentPage: page,
                                    totalItems: count
                                  };
                            let i = index
                          "
                        >
                          <td>{{ i + 1 }}</td>
                          <td>{{ data.org_name }}</td>
                          <td>{{ data.app_desc }}</td>
                          <td>{{ data.menu_desc }}</td>
                          <td>{{ data.sub_desc }}</td>
                          <td>{{ data.role_desc }}</td>
                          <td>
                            <ui-switch
                              size="small"
                              [(ngModel)]="data.status"
                              (change)="onSwitchRoleMenu($event, data)"
                            >
                            </ui-switch>
                          </td>
                          <td>
                            <div class="btn-group btn-group-sm">
                              <button
                                class="btn-primary"
                                (click)="roleMenuDelete(data.map_id)"
                              >
                                <i class="fa fa-trash-o"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #noData>
                        <tr>
                          <td colspan="11" class="text-center">No Roles</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                  <nav class="Pager2 mx-auto" aria-label="pagination example">
                    <ul class="pagination justify-content-center">
                      <!--Arrow left-->
                      <label class="float-right">
                        <pagination-controls
                          previousLabel="PREV"
                          nextLabel="NEXT"
                          responsive="true"
                          (pageChange)="handlePageChange($event)"
                          id="myqrypage"
                        ></pagination-controls>
                      </label>

                      <li class="page-item">
                        <select
                          class="form-control2 per-page-10"
                          (change)="getNumberPerPage($event)"
                        >
                          <option value="10" selected>10 per page</option>
                          <option value="20">20 per page</option>
                          <option value="30">30 per page</option>
                          <option value="40">40 per page</option>
                          <option value="50">50 per page</option>
                        </select>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <!-- end table  -->

            <!-- end of component -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
